{
  "actions": "Akcie",
  "actionsAvailable": "Dostupné akcie.",
  "clearSelection": "Vymazať výber",
  "selected": "{count, plural, =0 {Žiadne vybraté položky} other {Počet vybratých položiek: #}}",
  "selectedAll": "Všetky vybraté položky"
}
